export const getFileUrl = (file) =>
  file && file.url ? file.url : process.env.REACT_APP_FILESTORAGE_URL + file.id;
